import { actionCreator } from 'utils';
import {
    LOAD_COSTS,
    SET_COST_PAGINATION,
    SET_COST_SORT,
    SET_COST_FILTER,
    RESET_COST_FILTERS,
    ADD_COST,
    EDIT_COST,
    SET_CHECKED_COST,
    TOGGLE_COST_STATUS,
} from '../types/costTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 10,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        'configuration_property.carrier_id': [],
        'configuration_property.property_value_id': [],
        configuration_type: [],
        'name.translate': '',
        'cost_durations.partner_id': [],
    },
    checked: [],
    add: {
        loading: [],
        success: [],
    },
    edit: {
        loading: [],
        success: [],
    },
    statusLoading: [],
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_COSTS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_COSTS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_COSTS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_COST_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_COST_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case SET_COST_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case RESET_COST_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case ADD_COST:
        return Object.assign({}, state, {
            add: {
                ...state.add,
                loading: state.add.loading.concat(action.data.configuration_id),
            },
        });

    case actionCreator(ADD_COST, 'res'):
        return Object.assign({}, state, {
            add: {
                ...state.add,
                loading: state.add.loading.filter(c => c !== action.id),
                success: state.add.success.concat(action.id),
            },
        });

    case actionCreator(ADD_COST, 'req'):
        return Object.assign({}, state, {
            add: {
                ...state.add,
                success: state.add.success.filter(c => c !== action.id),
            },
        });

    case actionCreator(ADD_COST, 'err'):
        return Object.assign({}, state, {
            add: {
                ...state.add,
                loading: state.add.loading.filter(c => c !== action.id),
            },
        });

    case EDIT_COST:
        return Object.assign({}, state, {
            edit: {
                ...state.edit,
                loading: state.edit.loading.concat(action.data.configuration_id),
            },
        });

    case actionCreator(EDIT_COST, 'res'):
        return Object.assign({}, state, {
            edit: {
                ...state.edit,
                loading: state.edit.loading.filter(c => c !== action.id),
                success: state.edit.success.concat(action.id),
            },
        });

    case actionCreator(EDIT_COST, 'req'):
        return Object.assign({}, state, {
            edit: {
                ...state.edit,
                success: state.edit.success.filter(c => c !== action.id),
            },
        });

    case actionCreator(EDIT_COST, 'err'):
        return Object.assign({}, state, {
            edit: {
                ...state.edit,
                loading: state.edit.loading.filter(c => c !== action.id),
            },
        });

    case SET_CHECKED_COST:
        return Object.assign({}, state, {
            checked: action.ids,
        });

    case TOGGLE_COST_STATUS:
        return Object.assign({}, state, {
            statusLoading: action.ids,
        });

    case actionCreator(TOGGLE_COST_STATUS, 'res'):
        return Object.assign({}, state, {
            statusLoading: [],
            checked: [],
        });

    case actionCreator(TOGGLE_COST_STATUS, 'err'):
        return Object.assign({}, state, {
            statusLoading: [],
        });

    default:
        return state;
    }
}
